import React, { useState, useContext, useEffect } from "react";

import {
  UxAnimatedIcon,
  UxIconAnimationEnum,
  UxIcon,
  UxIconEnum,
  UxRadialProgress,
  UxPriorityEnum,
  UxSizeEnum,
  eventHelper
} from "@imaginelearning/mps-ux-component-library";
import { ServiceStatusEnum, IStudentRewardProgress, ILevel } from "@imaginelearning/mps-api-service";
import { RewardContext } from "../../context-providers/reward.provider";
import "./user-reward-stars.scss";
import useTheme from "../../hooks/usetheme";
import useGradeRange from "hooks/usegraderange";

function UserRewardStars(props: any) {
  const [showShower, setShowShower] = useState(false);
  const [animationType, setAnimationType] = useState("");
  const [currentPoints, setCurrentPoints] = useState(0);
  const [radialProgressValue, setRadialProgressValue] = useState(0);
  const { rewardState, contextCurrentLevelData, setContextCurrentLevelData } = useContext(RewardContext);
  const { isKto8 } = useGradeRange();

  useEffect(() => {
    let lastCelebratedLevel: any = null;
    let radialProgress: any = null;
    if (rewardState.status === ServiceStatusEnum.LOADED) {
      const studentRewardProgressData = rewardState.response as IStudentRewardProgress;
      lastCelebratedLevel = studentRewardProgressData.lastCelebratedLevel;
      let currentLevelPoints = null;
      let nextLevelPoints = null;
      const currentLevelData = studentRewardProgressData.levels.filter(
        (level: any) => String(studentRewardProgressData.currentLevel) === String(level.name)
      );
      if (currentLevelData && currentLevelData.length > 0) {
        currentLevelPoints = (currentLevelData[0] as ILevel).points;
      }
      const nextLevelData = studentRewardProgressData.levels.filter(
        (level: any) => String(studentRewardProgressData.currentLevel + 1) === String(level.name)
      );
      if (nextLevelData && nextLevelData.length > 0) {
        nextLevelPoints = (nextLevelData[0] as ILevel).points;
      }
      if (currentLevelPoints && nextLevelPoints) {
        radialProgress = Number((currentLevelPoints.earned / nextLevelPoints.required) * 100);
      }
      if (contextCurrentLevelData && contextCurrentLevelData.points !== studentRewardProgressData.currentPoints) {
        setShowShower(true);
        setAnimationType("SHOWER");
      }
      if (lastCelebratedLevel !== studentRewardProgressData.currentLevel) {
        setShowShower(true);
        setTimeout(() => {
          setAnimationType("PULSE");
        }, 2000);
      }
      setCurrentPoints(studentRewardProgressData.currentPoints);
      setRadialProgressValue(radialProgress);
      setContextCurrentLevelData({
        level: studentRewardProgressData.currentLevel,
        points: studentRewardProgressData.currentPoints
      });
    }
  }, [rewardState, contextCurrentLevelData, setContextCurrentLevelData]);

  return (
    <>
      {rewardState.status === ServiceStatusEnum.LOADED && (
        <div>
          <div className="starbar-container text-white px-3">
            <div
              className="starbar-hook align-self-center cursor-pointer d-flex"
              {...eventHelper(
                () => {
                  setAnimationType("");
                  setShowShower(false);
                  props.onStarBarClick();
                },
                { tabIndex: 0 }
              )}
            >
              {isKto8 && (
                <>
                  <div role="status" className="current-points px-3 align-self-center">
                    <span>{currentPoints}</span>
                  </div>
                  <UxRadialProgress
                    value={radialProgressValue || 0}
                    pathColor={UxPriorityEnum.INFO}
                    strokeWidth={14}
                    styles={{
                      rotation: 0.65
                    }}
                    items={
                      <UxAnimatedIcon
                        icon={{
                          icon: UxIconEnum.STAR,
                          size: UxSizeEnum.MEDIUM
                        }}
                        alt="Star"
                        enabled={showShower}
                        animationType={
                          animationType === "SHOWER" ? UxIconAnimationEnum.SHOWER : UxIconAnimationEnum.PULSE
                        }
                        className="star-icon"
                      />
                    }
                  />
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {rewardState.status === ServiceStatusEnum.LOADING && <UxIcon icon={UxIconEnum.CIRCLE_NOTCH} />}
      {rewardState.status === ServiceStatusEnum.ERROR && null}
    </>
  );
}

export default UserRewardStars;
